export default __webpack_public_path__ + "static/music-peaceful-5ef2df16f76848df713579e4d1f483af.jpg";